module.exports = "/images/vendor/flag-icon-css/flags/1x1/ly.svg?050ff9b00cb235a2a81bccfac78d6ac9";